import React,{useEffect, useState} from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import  './Resources/Actions.css';
import './App.css';

export default function Expensesreport(){
    const[dlist,setDlist] = useState([]);
    const[date, setDate] = useState(new Date().toISOString().slice(0,10));
    const [enddate,setEnddate] = useState(new Date().toISOString().slice(0,10));
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const usertype = parseInt(localStorage.getItem("utype"));
    const [userid,setUserid] =useState(parseInt(localStorage.getItem("userid")));
    const [checked, setChecked] = useState(false);
    var i = 0;

    useEffect(()=>{
    if(usertype === 1) 
    {

        if(checked === false)
        {
        fetch(API_URL+"api/Expense/GetExpenses?sdate="+date+"&edate="+enddate)
        .then(response => response.json())
        .then(data => {setDlist(data)}) 
        }
        else 
        {
            fetch(API_URL+"api/Expense/GetExpensesByUser?sdate="+date+"&edate="+enddate+"&userid="+userid)
            .then(response => response.json())
            .then(data => {setDlist(data)});
        }
    }
       
    else
    { 

        fetch(API_URL+"api/Expense/GetExpensesByUser?sdate="+date+"&edate="+date+"&userid="+userid)
        .then(response => response.json())
        .then(data => {setDlist(data)});
    }

    },[date,enddate,userid,checked])

    const Total = dlist.length > 0 ? dlist.reduce((tot,el)=>tot+ el.ExpenseAmount,0) : 0;
    
    return(
        <>
        <div className="reportheader"> 
            Expenses Report
            <Navbar/>
        </div> 
        <div style={{backgroundColor:"lightskyblue",padding:"10px"}}>
        {usertype === 1 ? <>
        <label for="startdate" style={{marginTop:"10px"}}>Start Date</label>
        <input id="startdate" type="date" defaultValue = {date} style={{height:"30px",width:"150px",marginTop:"5px",marginLeft:"5px"}} onChange={e => {setDate(e.target.value)}}></input><br/>
        <label for="enddate"  style={{marginTop:"10px",marginLeft:"8px"}}>End Date</label>
        <input id="enddate" type="date" defaultValue = {date} style={{height:"30px",width:"150px",marginTop:"5px",marginLeft:"4px"}} onChange={e => {setEnddate(e.target.value)}} ></input><br/>
        <input type="checkbox" id='byuser' style={{height:"18px",width:"18px"}} onChange={(e)=>{setChecked(!checked); checked ? document.getElementById('userid').disabled = true : document.getElementById('userid').disabled = false}}/><label>By</label><br/>
        <label for="userid" style={{marginTop:"10px",marginLeft:"8px"}}>UserID</label>
        <input id="userid" defaultValue='0' style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"20px"}} onChange={(e)=>{setUserid(e.target.value)}}  disabled></input>
        </> : <>
        <label for="startdate" style={{marginTop:"10px"}} >Start Date</label>
        <input id="startdate" type="date" defaultValue = {date} style={{height:"30px",width:"150px",marginTop:"5px",marginLeft:"5px"}} readOnly></input><br/><br/>
        </>}
        
        </div>
        <table style={{width:"100%",marginTop:"10px",marginBottom:"40px"}}> 
            <th>E.No</th>
            <th>Date</th>
            <th>Head</th>
            <th>Description</th>
            <th>Amount</th>

            {dlist.length > 0 ? <>
            {dlist.map(expense =>{return(<tr>
            <td>{expense.ExpenseId}</td>
            <td style={{textAlign:"center",width:"100px"}}>{expense.EntryDate.slice(8,10)}-{expense.EntryDate.slice(5,7)}-{expense.EntryDate.slice(0,4)}</td>
            <td style={{textAlign:"left"}}>{expense.ExpenseHead}</td>
            <td>{expense.Description}</td>
            <td>{expense.ExpenseAmount}</td>
        </tr>)})}
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td style ={{fontWeight:"bolder"}}>Total</td>
            <td style ={{fontWeight:"bolder"}}>{Total}</td>
            </tr></> : <></>}
        </table>
        <button type="button" className="backbutton" onClick={()=>{navigate('/loandetails')}}>Back</button>
        </>
    )
}